import { UserActionRequest } from "../../../openapi";
import { getAccessToken, parseJwt } from "../../common/utils/parseJwt";
import { UserProfile } from "oidc-client-ts";

export interface TProps {
  cdOperation: string;
  description: string;
}

export const buildAuditRequestBody = ({
  cdOperation,
  description,
}: TProps): UserActionRequest => {
  const token = getAccessToken();
  const parsed: UserProfile = parseJwt(token!);

  return {
    cdOperation,
    description,
    operation: "wbh_ee",
    user: parsed.upn as string,
  };
};
